import { TabPanel } from "@mui/lab";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useTabSearchParams from "@entrilia/shared/hooks/useTabSearchParams";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import PageTabs from "../../../common/PageTabs";
import MetricsTab from "./MetricsTab";

const tabValues = ["active", "inactive"] as const;

const tabPanelSx = { flex: 1, minHeight: 0, px: 3, pt: 2.5, width: "100%" };

const MetricsPage = () => {
  usePageTitle("Metrics");

  const { selectedTab, onTabChange } = useTabSearchParams(tabValues);

  return (
    <>
      <GeneralPageHeader title="Metrics" hideBorderLine />

      <PageTabs tabs={tabValues} labels={["Active", "Inactive"]} value={selectedTab} onChange={onTabChange}>
        <TabPanel value="active" sx={tabPanelSx}>
          <MetricsTab displayFilter="active" />
        </TabPanel>
        <TabPanel value="inactive" sx={tabPanelSx}>
          <MetricsTab displayFilter="inactive" />
        </TabPanel>
      </PageTabs>
    </>
  );
};

export default MetricsPage;
